export default function currency(value: string | number): string {
  if (typeof value == "string") {
    value = value.replace(",", ".");
  }

  if (typeof value !== "number") {
    value = value.toString();
  }

  const numericalValue = parseFloat(value as string);

  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return formatter.format(numericalValue);
}
